import { useState, useEffect } from "react";
import { Box, Typography, Divider, Paper } from "@mui/material";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import calendar from "dayjs/plugin/calendar";
import TokenError from "../tokenError";
import { makeGetRequestToUrl } from "../commonFunc";
import config from "../../config/config";
import { DatePicker,  LocalizationProvider } from "@mui/x-date-pickers";
import { Grid2 } from "@mui/material";
import { Label } from "flowbite-react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useNavigate,useLocation } from "react-router-dom";

dayjs.extend(relativeTime);
dayjs.extend(calendar);

const NotificationShow = () => {
    const [tokenExpired, setTokenExpired] = useState(false);
    const location = useLocation();
    const [notificationsList, setNotificationsList] = useState([]);
    const serverUrl = config.serverUrl;
    const initialDate = location.state?.initialDate 
        ? dayjs(location.state.initialDate)
        : dayjs();


    const [startDateFilter, setStartDateFilter] = useState(initialDate.startOf('day'));
    const [endDateFilter, setEndDateFilter] = useState(dayjs().endOf('day'));
    const date_format_dd_mm_yy = localStorage.getItem('date_format_dd_mm_yy');
    const utcOffsetVal = parseInt(localStorage.getItem('utc_offset'));


    useEffect(() => {
        fetchNotifications();
    }, [startDateFilter, endDateFilter]);

    const Navigate = useNavigate();

    const handleSingleNotificationClick = (notification) => {

    if (notification.flag === 2000) {
        Navigate('/mapview?engagement_id=' + notification.data?.trip_engagement_id + '&city_id=' + notification.data?.city_id);
    }
    if(notification.flag === 2001){
        Navigate('/scheduled-bookings?ride_id=' + notification.data?.ride_id + '&city_id=' + notification.data?.city_id);
    }
    if(notification.flag === 913){
        Navigate('/support-chat?chat_id=' + notification.data?.chat_id + '&user_type=' + notification.data?.user_type );
    }
    if(notification.flag === 2004){
        Navigate(`/?driver_id=${notification.data.driver_id}&city_id=${notification.data.city_id}&ts=${notification.logged_on}`);  
    }
    };

    // const formatNotificationTime = (dateString) => {
    //     if (!dateString) return "";

    //     const offset = Number.isFinite(utcOffsetVal) ? utcOffsetVal : 0;
    //     const localDate = dayjs(dateString).add(offset, "minute");

    //     const now = dayjs(); 

    //     const diffInDays = now.startOf("day").diff(localDate.startOf("day"), "day");

    //     if (diffInDays === 0) return "Today";
    //     if (diffInDays === 1) return "Yesterday";
    //     if (diffInDays < 7) return localDate.format("dddd");

    //     return localDate.format("MMM D, YYYY");
    // };

    // const formatTime = (isoString) => {
    //     if (!isoString) return "";

    //     const date = new Date(isoString);
    //     const offset = Number.isFinite(utcOffsetVal) ? utcOffsetVal : 0;
    //     const localDate = new Date(date.getTime() + offset * 60000);

    //     const hours = localDate.getHours();
    //     const minutes = localDate.getMinutes();

    //     const ampm = hours >= 12 ? "pm" : "am";
    //     const formattedHours = hours % 12 || 12;
    //     const formattedMinutes = String(minutes).padStart(2, "0");

    //     return `${formattedHours}:${formattedMinutes} ${ampm}`;
    // };

    const formatNotificationTime = (dateString) => {
        if (!dateString) return "";

        const localDate = dayjs(dateString);   // No custom UTC offset

        const now = dayjs();

        const diffInDays = now.startOf("day").diff(localDate.startOf("day"), "day");

        if (diffInDays === 0) return "Today";
        if (diffInDays === 1) return "Yesterday";
        if (diffInDays < 7) return localDate.format("dddd");

        return localDate.format("MMM D, YYYY");
    };

    const formatTime = (isoString) => {
        if (!isoString) return "";

        const date = new Date(isoString); // uses browser/system timezone automatically

        const hours = date.getHours();
        const minutes = date.getMinutes();

        const ampm = hours >= 12 ? "pm" : "am";
        const formattedHours = hours % 12 || 12;
        const formattedMinutes = String(minutes).padStart(2, "0");

        return `${formattedHours}:${formattedMinutes} ${ampm}`;
    };

    const fetchNotifications = async () => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/panel/fetch_notifications';
            const body = { 
                token,
                start_date: startDateFilter.format('YYYY-MM-DD'),
                end_date: endDateFilter.format('YYYY-MM-DD'),
            };
            const response = await makeGetRequestToUrl(url, body);

            if (response.flag == 200) {
                setNotificationsList(response.data);
            } else {
                console.error('Unexpected response format:', response);
            }
        } catch (err) {
            console.error('Error fetching notifications:', err);
        }
    }

        const handleStartDateChange = (newValue) => {
        if (!newValue) {
            setStartDateFilter(null);
            return;
        }
        
        // If new start date would make range > 7 days, adjust end date
        if (endDateFilter && endDateFilter.diff(newValue, 'day') > 6) {
            setEndDateFilter(dayjs(newValue).add(6, 'day').endOf('day'));
        }
        setStartDateFilter(dayjs(newValue).startOf('day'));
        };

        const handleEndDateChange = (newValue) => {
        if (!newValue) {
            setEndDateFilter(null);
            return;
        }
        
        // If new end date would make range > 7 days, adjust start date
        if (startDateFilter && newValue.diff(startDateFilter, 'day') > 6) {
            setStartDateFilter(dayjs(newValue).subtract(6, 'day').startOf('day'));
        }
        setEndDateFilter(dayjs(newValue).endOf('day'));
        };

    return (
        <Box sx={{ padding: "0px" }}>
            {tokenExpired && <TokenError />}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Notification History
            </Typography>

            <Grid2 container spacing={1.5} xs={12} md={8} alignItems="flex-end" sx={{ marginTop: '1%',marginBottom: '1%'}}>
                <Grid2 item>
                    <Label>Start Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '44px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px',
                                    minWidth:'190px'
                                }
                            }}
                            value={startDateFilter}
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                            onChange={handleStartDateChange}
                            maxDate={endDateFilter || undefined}
                            minDate={endDateFilter ? dayjs(endDateFilter).subtract(6, 'day') : undefined}
                        />
                    </LocalizationProvider>
                </Grid2>

                <Grid2 item>
                    <Label>End Date:</Label><br/>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            format={date_format_dd_mm_yy ? "DD/MM/YYYY" : "YYYY/MM/DD"}
                            slotProps={{ 
                                textField: { 
                                    size: 'small',
                                    error: endDateFilter && startDateFilter && startDateFilter.isAfter(endDateFilter)
                                } 
                            }}
                            sx={{
                                width: '190px',
                                '& .MuiInputBase-root': {
                                    height: '44px',
                                    borderRadius: '8px',
                                    backgroundColor: '#FFFFFF',
                                    marginTop:'4px',
                                    minWidth:'190px'
                                }
                            }}
                            value={endDateFilter}
                            onChange={handleEndDateChange}
                            minDate={startDateFilter || undefined}
                            maxDate={startDateFilter ? dayjs(startDateFilter).add(6, 'day') : undefined}
                        />
                    </LocalizationProvider>
                </Grid2>
            </Grid2>

            {/* Notification List */}
            <Paper
                elevation={0}
                sx={{
                    borderRadius: "12px",
                    backgroundColor: "#F9FAFB",
                    padding: "20px",
                }}
            >
                {(() => {
                    const filteredNotifications = notificationsList.filter((item) => {
                        if (!item || !item.logged_on) return false;
                        if (!startDateFilter || !endDateFilter) return true; // Show all if no date selected
                        const notificationDate = dayjs(item.logged_on).format('YYYY-MM-DD');
                        const startDateStr = startDateFilter.format('YYYY-MM-DD');
                        const endDateStr = endDateFilter.format('YYYY-MM-DD');
                        return notificationDate >= startDateStr && notificationDate <= endDateStr;
                    });

                    if (filteredNotifications.length === 0) {
                        return (
                            <Box sx={{ 
                                textAlign: 'center', 
                                padding: '40px 0',
                                color: '#6B7280'
                            }}>
                                <Typography variant="body1">
                                    {startDateFilter && endDateFilter 
                                        ? `No notifications found for ${startDateFilter.format('MMMM D, YYYY')} to ${endDateFilter.format('MMMM D, YYYY')}`
                                        : 'No notifications available'}
                                </Typography>
                            </Box>
                        );
                    }

                    return filteredNotifications.map((item, index) => (
                    <Box
                        key={item.id}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "12px 16px",
                            borderRadius: "10px",
                            mb: 1.5,
                            backgroundColor: "#fff",
                            transition: "all 0.25s ease",
                            cursor: "pointer",
                            "&:hover": {
                                backgroundColor: "#F1F5FF",
                                transform: "translateY(-2px)",
                            },
                        }}
                        onClick={()=>handleSingleNotificationClick(item)}
                    >
                        {/* Left small date box */}
                        {(() => {
                            const d = new Date(item.logged_on);
                            const day = String(d.getDate()).padStart(2, "0");
                            const month = d.toLocaleString("default", { month: "short" }); // e.g. "Nov"
                            const year = d.getFullYear();
                            return (
                                <Box
                                    sx={{
                                        width: 72,
                                        minWidth: 72,
                                        height: 72,
                                        borderRadius: 2,
                                        backgroundColor: "#F8FAFF",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mr: 2,
                                        boxShadow: "inset 0 -1px 0 rgba(0,0,0,0.02)",
                                    }}
                                >
                                    <Typography sx={{ fontSize: 22, fontWeight: 700, lineHeight: 1,color: '#1c5bed' }}>
                                        {day}
                                    </Typography>
                                    <Typography sx={{ fontSize: 13, fontWeight: 600, mt: 0.25,color: '#6B7280' }}>
                                        {month}
                                    </Typography>
                                    <Typography sx={{ fontSize: 12, color: "#6B7280", mt: 0.25 }}>
                                        {year}
                                    </Typography>
                                </Box>
                            );
                        })()}

                        {/* Middle - Title and Message */}
                        <Box
                            sx={{
                                flexGrow: 1,
                                pr: 2,
                                display: "flex",
                                flexDirection: "column",
                                minWidth: 0, // important for text truncation
                            }}
                        >
                            <Typography
                                variant="subtitle1"
                                sx={{
                                    fontWeight: 700,
                                    color: "#1c5bed",
                                    fontSize: { xs: 14, sm: 15 },
                                    mb: 0.3,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}
                                title={item.title || item.message}
                            >
                                {item.title || "Notification"}
                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{
                                    color: "#6B7280",
                                    fontSize: 14,
                                    fontWeight: 500,
                                    lineHeight: 1.3,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                }}
                            >
                                {item.message}
                            </Typography>
                        </Box>

                        {/* Right - Time (top) and Date (bottom) */}
                        <Box
                            sx={{
                                flexShrink: 0,
                                width: { xs: 92, sm: 110 },
                                textAlign: "right",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-end",
                                justifyContent: "center",
                                ml: 1,
                            }}
                        >
                            <Typography sx={{ fontSize: 13, fontWeight: 700 }}>
                                {formatTime(item.logged_on)}
                            </Typography>
                            <Typography sx={{ fontSize: 12, color: "#6B7280", mt: 0.25 }}>
                                {formatNotificationTime(item.logged_on)}
                            </Typography>
                        </Box>
                    </Box>

                    ));
                })()}
            </Paper>
        </Box>
    );
};

export default NotificationShow;
